import { GridApi } from 'ag-grid-community';
import { Injectable } from '@angular/core';
import { PreferenceStorageService } from './preference-storage.service';

@Injectable({
  providedIn: 'root',
})
export class SortStateService {
  constructor(protected preferenceService: PreferenceStorageService) {}

  saveSortState(gridApi: GridApi, key: string): void {
    const sortState = gridApi
      .getColumnState()
      .filter((column: any) => column.sort)
      .map((column: any) => ({
        colId: column.colId,
        sort: column.sort,
        sortIndex: column.sortIndex,
      }));
    this.preferenceService.setPreference(key, sortState);
  }

  restoreSortState(gridApi: GridApi, key: string): void {
    const sortState = this.preferenceService.getPreference(key);
    if (sortState) {
      sortState.forEach((state: any) => {
        gridApi.applyColumnState({
          state: [
            {
              colId: state.colId,
              sort: state.sort,
              sortIndex: state.sortIndex,
            },
          ],
          applyOrder: true,
        });
      });
    }
  }
}
